<!-- <p>zatca-phase-two works!</p> -->

<div class="account-setting white-bg">
	<div class="account-setting__content">
		<app-generate-certificate></app-generate-certificate>
	</div>
</div>